import { render, staticRenderFns } from "./consumer-content.vue?vue&type=template&id=df7f5104&scoped=true&"
import script from "./consumer-content.vue?vue&type=script&lang=js&"
export * from "./consumer-content.vue?vue&type=script&lang=js&"
import style0 from "./consumer-content.vue?vue&type=style&index=0&id=df7f5104&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df7f5104",
  null
  
)

export default component.exports